import script from "./improve.vue?vue&type=script&setup=true&lang=js"
export * from "./improve.vue?vue&type=script&setup=true&lang=js"

import "./improve.vue?vue&type=style&index=0&id=5d6d2096&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6d2096"]])

export default __exports__